<template>
  <Admin>
    <v-main v-if="!isProductListLoading" class="wrapper">
        <v-container v-if="!selectedCompanyProductList?.isFixedAssetCount" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
            <h1>Fixed Assets Count</h1>
        </div>
        <v-divider/> 
        <v-row justify="center">
          <v-col>              
            <assetsCountTable></assetsCountTable>
          </v-col>
        </v-row>
        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage">
              <option
                v-for="option in itemsPerPageOptions"
                :key="option"
                :value="option"
                :selected="option === itemsPerPage"
              >
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination v-model="currentPage" :length="numPages" :total-visible="10" @input="paginate"></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนรายการทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>
<script >
import Admin from '@/components/admin/admin-main-template.vue'
import fc from "@/firebaseConfig"; 
import firebase from "firebase/app";
import "firebase/auth";
import {mapState, mapActions} from "vuex";
import assetsCountTable from '@/components/admin/fixedAssets/assetsCountTable.vue';
const axios = require('axios');

export default {
    name: "fixedAssetSessionCount",
    components: {
        Admin,
        assetsCountTable
    },
    data(){
        return { 
            sysnSuccess: false,
            itemsPerPage: 20,
            currentPage:1,
            itemsPerPageOptions: [10, 20, 30, 40, 50],
        }
    },
    computed: {
        ...mapState({
          assetCounts: (state) => state.fixedAssets.assetCounts,
           selectedCompanyProductList: (state) =>
          state.companies.selectedCompanyProductList,
          isProductListLoading: (state) => state.companies.isProductListLoading,
        }),
        numPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        },
        totalItems() {
            return this.assetCounts.length;
        },
    },
    methods: {
        paginate() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = Number.parseInt(startIndex) +  Number.parseInt(this.itemsPerPage);

            if (startIndex != 0 && startIndex >= this.items.length) {
                // Reset to page 1 if the current page is out of range
                console.warn("Page exceeds available data. Resetting to page 1");
                this.currentPage = 1;
                this.paginate();  // Re-run pagination for page 1
            } else {
                // If the page is within range, slice the items as usual
                this.displayedItems = this.items.slice(startIndex, endIndex);
            }
        }
    },
};
</script>

<style scoped>
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.total-item {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>